export const getSelectedPackagesCount = (selectedFlavors) => {
    return Object.values(selectedFlavors).reduce((acc, flavorCount) => acc + flavorCount, 0);
};
//# sourceMappingURL=getSelectedPackagesCount.js.map